import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import ObfuscationLink from '~/components/Layout/ObfuscationLink.vue';
export default defineComponent({
  name: 'LabeledLinkStandard',
  components: {
    ObfuscationLink: ObfuscationLink
  },
  props: {
    image: {
      type: Object,
      default: function _default() {}
    },
    link: String
  },
  setup: function setup() {
    var route = useRoute();
    var obfuscatedActived = computed(function () {
      return route.fullPath.toString() !== '/';
    });
    return {
      obfuscatedActived: obfuscatedActived
    };
  }
});